"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filters_1 = require("./filters");
var helpers_1 = require("./helpers");
var immutable_1 = require("immutable");
var _initial = immutable_1.Map();
/**
 * Used to serialize filters into request format for Search API
 * @param filters array of filters
 */
var formatFilters = function (filters) {
    return filters
        .filter(function (value) { return !!value && !value.isEmpty(); })
        .map(function (values, name) {
        var type = filters_1.getFacetType(values.first());
        return immutable_1.Map({
            name: name,
            type: type,
            values: (type === 'range' && values) ||
                (type === 'category' && values.map(function (value) { return ({ value: value.join('>') }); })) ||
                values.map(function (value) { return ({ value: value }); }),
        });
    })
        .toList();
};
/**
 * Used to create serializer for each request field
 * @param key
 * @returns function, which takes field value and returns its serialized value
 */
var formatQueryField = function (key) {
    return ({
        filters: formatFilters,
    }[key] || helpers_1.identity);
};
/**
 * Used to build new state out of response meta, previous state and possible default values
 * This procedure is complex mainly because of filters, that may vary with each request quite heavily,
 * ranging from a new filter value added, to addition and removal of new filters
 * @param prev previous Agent state
 * @param next response metadata
 * @param defaults default values for agent
 */
exports.queryToState = function (prev, next, defaults) {
    var fields = prev.filter(function (_, key) { return next.has(key); });
    /**
     * Walk trough old keys to prevent new fields tracking
     */
    return fields.keySeq().reduce(function (acc, key) {
        var nextField = next.get(key);
        /**
         * Skip if value equals default one
         */
        if (defaults && defaults.get(key) === nextField)
            return acc;
        /**
         * Return new value without formating
         */
        if (key !== 'filters')
            return acc.set(key, nextField);
        /**
         *  Reduce filters
         *  from: [{ name: string, type: string, values:[{ value: any }]}]
         *  to: { [name: string]: [any[] }
         */
        return acc.set(key, nextField.reduce(function (filters, nextFilter) {
            var nextFilterName = nextFilter.get('name');
            var type = nextFilter.get('type');
            var values = nextFilter
                .get('values')
                .filter(function (v) { return !defaults ||
                ((type === 'range' && !defaults.hasIn([key, nextFilterName])) ||
                    !defaults.hasIn([key, nextFilterName, v.get('value')])); })
                .map(function (v) {
                return (type === 'range' && v) ||
                    (type === 'category' && v.get('value').split('>')) ||
                    v.get('value');
            });
            return values.isEmpty() ? filters : filters.set(nextFilterName, values);
        }, _initial));
    }, _initial);
};
/**
 * Used to serialize agent state back to query
 * @param state Agent state
 */
exports.stateToQuery = function (state) {
    return state.map(function (value, key) { return formatQueryField(key)(value); });
};
//# sourceMappingURL=format.js.map